/**
 *@author yudeping
 *内置字段控件
 */

import Component from '../../../lib/component'
import {AutoSelect} from "../../util/autoSelect/autoSelect"
import {FormService} from "../../../services/formService/formService";
import './buildin-control.scss';
import template from './buildIn-control.html';
import WXtemplate from './buildIn-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';

let config={
    template:template,
    binds:[
        {
            event: 'click',
            selector: '.ui-selector',
            callback: function(){
                this.events.selectChoose(this.data);
            }
        },
        {
            event: 'click',
            selector: '.ui-history',
            callback: function(){
                this.events.emitHistory(this.data)
            }
        },
        {
            event: 'click',
            selector: '.add-item',
            callback: function(){
                this.events.addNewBuildIn(this.data);
            }
        }
    ],
	actions:{
    	init(){
		    this.data.isInit=true;
		    // if(this.data.is_view){
			    for(let k in this.data.options) {
				    if(this.data.value == this.data.options[k].value) {
					    this.el.find('.dropdown').attr('title',this.data.options[k].label)
				    }
			    }
		    // }
		    if(!this.data.be_control_condition) {
			    this.actions.renderSelect();
		    }
		    // this.data.isInit=false;
	    },
		renderSelect(){
			let dropdown=this.el.find('.dropdown');
			dropdown.bind('click',()=>{
				if(this.data.is_view){
					return;
				}
				dropdown.empty();
				dropdown.removeClass('initSelect');
				this.actions.createDropDown();
				dropdown.unbind('click');
			})
			dropdown.css('width',this.data.width?this.data.width:'240px');
			if(this.data.is_view){
				dropdown.css('background-color','#ebebe4');
			}
            if(this.data.value ){
				for(let item of this.data.options){
					if(item.value == this.data.value){
						this.el.find('.dropdown span').text(item.label);
					}
				}
            }
		},
		iconCheck(){
			if(!this.data.is_view && this.data.can_add_item){
				this.el.find('.add-item').css('visibility','visible').addClass('icon-fl');
			}
			if(!this.data.is_view){
				this.el.find('.ui-selector').css('visibility','visible').addClass('icon-fl');
			}
			if(this.data.is_view){
                this.el.find('.dropdown-text').css('color','#666666');
			}
			if(this.data.history){
				this.el.find('.ui-history').css('visibility','visible').addClass('icon-fl');
			}
		},
		createDropDown(){
			if(!this.data.be_control_condition) {
				let _this=this;
				let el=this.el.find('.dropdown');
				let data=FormService.createSelectJson(this.data);
				data.onSelect=function(data){
					if(_this.data.isInit || !data || data.length == 0 ){
						if(!_this.data.isInit){
							_this.data.value='';
                            _this.data.selectLabel = '';
							_.debounce(function(){_this.events.changeValue(_this.data)},200)();
						}
						return;
					}
					_this.data.selectLabel=data[0]['name'];
					_this.data.value=data[0]['id'];
					_.debounce(function(){_this.events.changeValue(_this.data)},200)();
				};
				let autoSelect=new AutoSelect({data:data});
				this.append(autoSelect,el);
				setTimeout(()=>{
					autoSelect.actions.showSelectBox();
				},0)
				this.data.isInit=false;
			}
		}
	},
    afterRender(){
    	this.actions.iconCheck();
       this.actions.init();
    },
    firstAfterRender: function () {
        //在添加子表单中内容未占满整个页面   有下拉框是  添加底部高度；
        let add_wf_body_heighe = $('#add-wf-body').height();
        if (add_wf_body_heighe) {
            let foot_display = $('#add-wf-body .workflow-foot.J_hide')[1].style.display; // 是否有审批流程
            if (foot_display == 'none') {
                $('#place-form').css('padding','20px 10px 179px');
            }
        }
	},
    beforeDestory(){
        this.el.off();
    }
}
let BuildInControl = Component.extend(config)
export default BuildInControl

let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:Object.assign({},config.actions,{
		createDropDown(){
			if(!this.data.be_control_condition) {
				let _this=this;
				let el=this.el.find('.dropdown');
				let data=FormService.createSelectJson(this.data);
				data.onSelect=function(data){
					if(_this.data.isInit || !data || data.length == 0 ){
						if(!_this.data.isInit){
							_this.data.value='';
						}
						return;
					}
					_this.data.value=data[0]['id'];
				};
				data.forbidSelect=true;
				let autoSelect=new AutoSelect({data:data});
				this.append(autoSelect,el);
				setTimeout(()=>{
					autoSelect.actions.showSelectBox();
				},0)
				this.data.isInit=false;
			}
		}
	}),
	afterRender(){
		this._super.afterRender();
		this.actions.init();
		this.actions.createDropDown();
	},
	beforeDestory:config.beforeDestory,
}
let BuildInControlWX=BaseControl.extend(WXconfig);
export {BuildInControlWX}


// WEBPACK FOOTER //
// app/components/form/buildIn-control/buildIn-control.js